/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter/types';
import {
    LoginResponseData,
    UiType,
    UserRole,
    MisLoginResponseData,
    MisAuthStatusResponseData,
    SimpleLoginFormData,
    // MisAuthError //Uncomment me to emulate 401 error
} from './authClient.typings';
import { makeMockResponse } from '../mockUtils';
import { delayedResponse } from '../companies/companiesMock';
import { Permit } from '../../../accessibility/permits';
import {
    CentralInspectorCabinet,
    DirectorCabinet,
    InspectorCabinet,
    OperatorCabinet,
    RegionalInspectorCabinet,
    TaxpayerCabinet,
} from '../../../accessibility/permitsMock';

export function addAuthMockApi(mockAdapter: MockAdapter): void {
    // Uncomment me to emulate 401 error
    // mockAdapter.onPost(/mis$/).reply(config => {
    //     // Emulate 401 on any first request
    //     const misAuthError: MisAuthError = {
    //         code: 1002,
    //     };
    //
    //     return delayedResponse(
    //         makeMockResponse(401, misAuthError, config),
    //         100
    //     );
    // });

    mockAdapter.onPost(/simple/).reply((config) => {
        const emailForRegionalInspector = 'r.admin@noogadev.com';
        const emailForCentralInspector = 'c.admin@noogadev.com';
        const emailForDirectorInspector = 'director@noogadev.com';
        const emailForAuditorInspector = 'auditor@noogadev.com';
        const emailForAuditorDirector = 'auditor_director@noogadev.com';

        const formData = Object.fromEntries(config.data) as SimpleLoginFormData;

        const getUiTypeFromUserName = (userName: string): UiType => {
            switch (userName) {
                case emailForRegionalInspector:
                    return UiType.RegionInspector;
                case emailForCentralInspector:
                    return UiType.CentralInspector;
            }
            return UiType.Inspector;
        };

        const getUserRolesFromUserName = (userName: string): UserRole[] => {
            switch (userName) {
                case emailForDirectorInspector:
                    return [UserRole.Director, UserRole.Admin, UserRole.Expert];
                case emailForAuditorInspector:
                    return [UserRole.Admin, UserRole.Auditor];
                case emailForAuditorDirector:
                    return [UserRole.Admin, UserRole.Auditor, UserRole.Director];
                case emailForRegionalInspector:
                    return [UserRole.RegionInspector];
                case emailForCentralInspector:
                    return [UserRole.CentralInspector];
            }
            return [UserRole.Admin];
        };

        const getPermitsFromUserName = (userName: string): Permit[] => {
            switch (userName) {
                case emailForDirectorInspector:
                    return DirectorCabinet;
                case emailForAuditorDirector:
                    return DirectorCabinet;
                case emailForRegionalInspector:
                    return RegionalInspectorCabinet;
                case emailForCentralInspector:
                    return CentralInspectorCabinet;
            }
            return InspectorCabinet;
        };

        const authData: LoginResponseData = {
            uiType: getUiTypeFromUserName(formData.username),
            roles: getUserRolesFromUserName(formData.username),
            permits: getPermitsFromUserName(formData.username),
            userId: 0,
            email: 'raman.kremko@noogadev.com',
            firstName: 'Raman',
            middleName: 'Sergeevich',
            lastName: 'Kremko',
        };

        return delayedResponse(makeMockResponse(200, authData, config), 100);
    });

    mockAdapter.onPost(/mis$/).reply((config) => {
        const authData: MisLoginResponseData = {
            verificationCode: 'mock173201C',
        };

        return delayedResponse(makeMockResponse(200, authData, config), 100);
    });

    let misRequestCount = 0;
    mockAdapter.onGet(/mis\/statuses$/).reply((config) => {
        const data: MisAuthStatusResponseData = {
            authenticationStatus: 'OUTSTANDING_TRANSACTION',
            users: null,
            errorCode: null,
        };
        misRequestCount++;
        if (misRequestCount === 1) {
            misRequestCount = 0;
            data.authenticationStatus = 'USER_AUTHENTICATED';
            data.users = [
                {
                    taxNumber: '8475938264847',
                    name: 'CASPOS" MƏHDUD MƏSULİYYƏTLİ CƏMİYYƏTİ',
                },
                {
                    taxNumber: '12349000000',
                    name: 'DATAPAY" QAPALI SƏHMDAR CƏMİYYƏTİ',
                },
                {
                    taxNumber: '12349000789',
                    name: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.',
                },
            ];
        }

        return delayedResponse(makeMockResponse(200, data, config), 100);
    });

    mockAdapter.onPost(/logout/).reply((config) => {
        return delayedResponse(makeMockResponse(200, null, config), 50);
    });

    mockAdapter.onPost(/mis\/complete$/).reply((config) => {
        const body = Object.fromEntries(config.data.entries());

        const authData: LoginResponseData = {
            uiType: body.uiType,
            roles: body.uiType,
            permits: body.uiType === UiType.Operator ? OperatorCabinet : TaxpayerCabinet,
            userId: 1,
            phone: '+994638000001',
            firstName: 'Raman',
            middleName: 'Sergeevich',
            lastName: 'Kremko',
        };

        return delayedResponse(makeMockResponse(200, authData, config), 1000);
    });
}
